import React from "react";
import WelcomeBanner from "./WelcomeBanner";
import { TimelineProgress, Checklist, OnboardingDocs } from "./InternWidgets";
import AttendanceWidget from "./AttendanceWidget";
import LeaveSummaryWidget from "./LeaveSummaryWidget";
import CalendarSection from "./CalendarSection";
import NotificationsPanel from "./NotificationsPanel";
import ChatWidget from "./ChatWidget";
import CertificateSection from "./CertificateSection";

function DashboardView({user}) {
  return (
    <>
      <WelcomeBanner />
      <TimelineProgress />
      <div className="grid-2 mb-20"><Checklist /><OnboardingDocs /></div>
      <div className="grid-2 mb-20"><AttendanceWidget /><LeaveSummaryWidget /></div>
      <div className="grid-2 mb-20"><CalendarSection /><NotificationsPanel /></div>
      <div className="grid-2 mb-20"><ChatWidget /><CertificateSection /></div>
    </>
  );
}

export default DashboardView;
